export enum SlideLayout {
  Split = 'split',
  Backdrop = 'backdrop',
  Table = 'table',
  Fullscreen = 'fullscreen',
  Video = 'video'
}
